import type { SharedSvgProps } from '.';

import React from 'react';

import styles from './index.module.scss';

const HeaderTypeLine = ({ style }: SharedSvgProps) => (
  <svg className={styles.Preview} fill="none" style={style} viewBox="0 0 92 62" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_272_16725)">
      <rect fill="url(#paint0_linear_272_16725)" height="62" rx="5" width="92" />
      <mask height="62" id="mask0_272_16725" maskUnits="userSpaceOnUse" width="118" x="10" y="15">
        <path
          d="M124 15H14C11.7909 15 10 16.7909 10 19V73C10 75.2091 11.7909 77 14 77H124C126.209 77 128 75.2091 128 73V19C128 16.7909 126.209 15 124 15Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_272_16725)">
        <path
          d="M124 15H14C11.7909 15 10 16.7909 10 19V73C10 75.2091 11.7909 77 14 77H124C126.209 77 128 75.2091 128 73V19C128 16.7909 126.209 15 124 15Z"
          fill="#F0F0F0"
        />
        <path d="M10 33.5H92" stroke="black" strokeOpacity="0.1" />
        <path d="M10 50.5H92" stroke="black" strokeOpacity="0.1" />
        <path
          d="M36 40H22C20.8954 40 20 40.8954 20 42C20 43.1046 20.8954 44 22 44H36C37.1046 44 38 43.1046 38 42C38 40.8954 37.1046 40 36 40Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          d="M62 40H48C46.8954 40 46 40.8954 46 42C46 43.1046 46.8954 44 48 44H62C63.1046 44 64 43.1046 64 42C64 40.8954 63.1046 40 62 40Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          d="M88 40H74C72.8954 40 72 40.8954 72 42C72 43.1046 72.8954 44 74 44H88C89.1046 44 90 43.1046 90 42C90 40.8954 89.1046 40 88 40Z"
          fill="black"
          fillOpacity="0.1"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_272_16725"
        x1="75.4143"
        x2="95.6437"
        y1="14.2082"
        y2="14.293"
      >
        <stop stopColor="#AE9ED4" />
        <stop offset="1" stopColor="#8AB0FF" />
      </linearGradient>
      <clipPath id="clip0_272_16725">
        <rect fill="white" height="62" rx="5" width="92" />
      </clipPath>
    </defs>
  </svg>
);

export default HeaderTypeLine;
